import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { Auth0Provider } from '@auth0/auth0-react';
import App from './App';
import { fetchConfig } from './utils/fetch-config';
import { initTheme } from './utils/theme';

initTheme();

const AppInit = () => {
  const [config, setConfig] = useState<any>(null);

  useEffect(() => {
    const getValidatorJson = async () => {
      const validatorJson = await fetchConfig();
      Object.assign(window, { data: validatorJson });
      setConfig(validatorJson.auth);
    };
    getValidatorJson();
  }, []);

  if (!config) return <div>Loading...</div>;

  return (
    <Auth0Provider
      domain={config?.AUTH0_DOMAIN}
      clientId={config?.AUTH0_CLIENT_ID}
      authorizationParams={{
        redirect_uri: window.location.href,
      }}
    >
      <App />
    </Auth0Provider>
  );
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <AppInit />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
